import { z } from 'zod';

const phoneNumber = z.object({
  e164: z.string().regex(/^\+[1-9]\d{1,14}$/),
});

export default phoneNumber;

export type PhoneNumber = z.infer<typeof phoneNumber>;
